// My Library → Meetings (CherryClipz Notetaker). Backend: emo/transcript/notetaker.py.

export const MEETINGS_TEXT = {
  INTRO:
    "Send CherryClipz Notetaker to a Google Meet, Zoom or Teams call. When the call ends, everyone on it gets an email with the call as a clip spreadsheet, a few clips already cut, and a quote from each speaker.",
  OWN_TITLE: "Your own Google Meet recordings, automatically",
  OWN_BODY:
    "Record your Meet call as usual (Activities → Recording). A few minutes after the recording lands in your Google Drive, it's in your Library and you get the email. No notetaker joins the call. Set it up once:",
  OWN_STEP_1: "Copy your script (it has your private link in it).",
  OWN_STEP_2: "Open script.google.com, click New project, delete what's there and paste.",
  OWN_STEP_3: "Choose “setup” in the menu at the top and press Run. Allow access when Google asks (Advanced → Go to project).",
  OWN_COPY: "Copy script",
  OWN_OPEN: "Open script.google.com",
  DRIVE_SOURCE: "from Drive",
  AUTO_TITLE: "Every meeting, automatically",
  AUTO_BODY:
    "Add this address as a guest on any calendar invite. The notetaker joins at the start time, and everyone on the invite gets the email. Moving or cancelling the invite moves or cancels the notetaker.",
  COPY: "Copy",
  COPIED: "Copied",
  NOW_TITLE: "Send it to a call",
  LINK_LABEL: "Meeting link",
  LINK_PLACEHOLDER: "https://meet.google.com/abc-defg-hij",
  RECORD_LABEL: "Record",
  RECORD_VIDEO: "Video + audio",
  RECORD_AUDIO: "Audio only",
  WHEN_LABEL: "When",
  WHEN_NOW: "Join now",
  WHEN_LATER: "Later",
  EMAILS_LABEL: "Also email (optional)",
  EMAILS_PLACEHOLDER: "jane@acme.com, sam@studio.com",
  EMAILS_NOTE: "You always get the email. Up to 10 guests here (everyone on a calendar invite gets it too); guests get view-only links.",
  SEND: "Send notetaker",
  SENDING: "Sending…",
  SENT_NOW: "The notetaker is on its way into the call.",
  SENT_LATER: "Scheduled. The notetaker will join on time.",
  LIST_TITLE: "Your notetakers",
  EMPTY: "No meetings yet.",
  CANCEL: "Cancel",
  CONSENT:
    "The notetaker joins under the name “CherryClipz Notetaker” and posts in the chat that it's recording. Let people know you're recording; some places require everyone's consent.",
  INVITE_SOURCE: "from invite",
  GUESTS: (n: number) => `${n} guest${n === 1 ? "" : "s"}`,
  ERROR_LOAD: "Couldn't load your meetings.",
  ERROR_SEND: "Couldn't send the notetaker.",
};

export const MEETING_STATUS_LABEL: Record<string, string> = {
  scheduled: "Scheduled",
  joining: "Joining",
  recording: "Recording",
  importing: "Making clips",
  ready: "Emailed",
  failed: "Failed",
  canceled: "Canceled",
};
